/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { getCookie } from '../utils/cookieUtils';

export default function Test() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const pid = getCookie("pid");
    const participantId = getCookie("participantId");
    setData({ pid: pid, participantId: participantId });
    console.log("pid: ", pid, "participantId: ", participantId);

  }, []);

  return (
    <Box sx={{ mt: 5, m: 1 }}>
      <Typography variant="h4" gutterBottom>
        Test Page
      </Typography>
      {data && <div>{data.pid} {data.participantId}</div>}
    </Box>
  );
}